'use strict';

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var currify = require('currify/legacy');

var squad = require('squad/legacy');

var apart = require('apart/legacy');

var unary = currify(function (fn, value) {
  return fn(value);
});

var notEmpty = function notEmpty(value) {
  return value;
};

var apply = currify(function (args, fn) {
  return fn.apply(void 0, _toConsumableArray(args));
});
module.exports = somefilter;

function somefilter(condition, filters) {
  if (!filters) {
    filters = condition;
    condition = notEmpty;
  }

  checkAll(condition, filters);
  var storify = store(condition);
  var process = apart(squad, condition, storify);
  var processingFilters = filters.map(unary(process)).reverse();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    processingFilters.some(apply(args));
    return storify();
  };
}

function store(condition) {
  var cache;
  return function (value) {
    var result;

    if (condition(value)) {
      cache = result = value;
    } else {
      result = cache;
      cache = null;
    }

    return result;
  };
}

function checkAll(condition, filters) {
  if (typeof condition !== 'function') throw Error('condition should be function!');
  if (!Array.isArray(filters)) throw Error('filters should be an array!');
  check('function', filters);
}

function check(type, array) {
  var getType = function getType(item) {
    return _typeof(item);
  };

  var notEqual = function notEqual(a, b) {
    return a !== b;
  };

  var wrong = function wrong(type) {
    throw Error("fn should be ".concat(type, "!"));
  };

  var wrongType = apart(wrong, type);
  var notType = apart(notEqual, type);
  if (!array.length) return wrongType(type);
  array.map(getType).filter(notType).forEach(wrongType);
}